export const hofPageQuery = (slug: string, languageCode: string) => `
query PageBySlugQuery {
  pages(filters: { slug: { eq: "${slug}" } }, locale: "${languageCode}") {
    components {
      ... on ComponentMainHofPage {
        bestsellers {
          title
          products {
            documentId
            name
            slug
            price
            discount
            productType
            isPreOrderable
            inventoryType
            variants(pagination: { pageSize: 50 }) {
              amount
              label
              uuid
              weight
            }
            images {
              alternativeText
              width
              height
              formats
              url
            }
            deliveryDates {
              documentId
              date
              isActive
            }
          }
        }
        categories {
          name
          slug
          products {
            documentId
            name
            slug
            price
            productType
            isPreOrderable
            inventoryType
            variants(pagination: { pageSize: 50 }) {
              amount
              label
              uuid
              weight
            }
            discount
            images {
              alternativeText
              width
              height
              formats
              url
            }
            deliveryDates {
              documentId
              date
              isActive
            }
          }
        }
      }
    }
  }
}
`;
